import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

type Range = { from: number; to: number }

const persistentSelectionKey = new PluginKey<Range | null>('persistentSelection')

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    persistentSelection: {
      setPersistentSelection: (range: Range) => ReturnType
      clearPersistentSelection: () => ReturnType
    }
  }
}

export const PersistentSelectionDecoration = Extension.create({
  name: 'persistentSelectionDecoration',

  addCommands() {
    return {
      setPersistentSelection:
        (range: Range) =>
        ({ tr, dispatch }) => {
          if (dispatch) tr.setMeta(persistentSelectionKey, range)
          return true
        },
      clearPersistentSelection:
        () =>
        ({ tr, dispatch }) => {
          if (dispatch) tr.setMeta(persistentSelectionKey, null)
          return true
        }
    }
  },

  addProseMirrorPlugins() {
    return [
      new Plugin<Range | null>({
        key: persistentSelectionKey,
        state: {
          init: () => null,
          apply: (tr, prev) => {
            const meta = tr.getMeta(persistentSelectionKey)
            if (meta !== undefined) return meta as Range | null
            if (prev && tr.docChanged) {
              return { from: tr.mapping.map(prev.from), to: tr.mapping.map(prev.to) }
            }
            return prev
          }
        },
        props: {
          decorations(state) {
            const range = persistentSelectionKey.getState(state)
            if (!range || range.from === range.to) return null
            return DecorationSet.create(state.doc, [
              Decoration.inline(range.from, range.to, { class: 'ps-persistent-selection' })
            ])
          }
        }
      })
    ]
  }
})
